import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "grouping-side-nav",
  templateUrl: "./grouping-side-nav.component.html",
  styleUrls: ["./grouping-side-nav.component.scss"],
})
export class GroupingSideNavComponent implements OnInit {
  @Input() dataConfigs;
  @Input() selectedDataConfig;

  @Output() selectNewDataConfig = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  selectSidebarElement(dataConfig) {
    this.selectNewDataConfig.emit(dataConfig);
  }

  getTitleForDataConfig(dataConfig) {
    return dataConfig["displayName"]
      ? dataConfig["displayName"]
      : dataConfig["aggregategroup_displayname"];
  }

  isSelected(dataConfig) {
    if (dataConfig.groupingTemplateId) {
      return (
        this.selectedDataConfig &&
        dataConfig.groupingTemplateId ==
          this.selectedDataConfig.groupingTemplateId
      );
    } else if (dataConfig.grouping_template_id) {
      return (
        this.selectedDataConfig &&
        dataConfig["grouping_template_id"] ==
          this.selectedDataConfig["grouping_template_id"]
      );
    } else {
      if (dataConfig["displayName"]) {
        return (
          this.selectedDataConfig &&
          dataConfig["displayName"] == this.selectedDataConfig["displayName"]
        );
      } else {
        return (
          this.selectedDataConfig &&
          dataConfig["aggregategroup_displayname"] ==
            this.selectedDataConfig["aggregategroup_displayname"]
        );
      }
    }
  }
}
